import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex } from 'roo-ui/components';

export const PaymentMethodSummaryContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  border-color: ${themeGet('colors.greys.alto')};
  padding: ${themeGet('space.4')};
`;
